<template>
  <div>
    <div class="sp_base_menu" :class="{top_header:isTop}">
      <MainLogo />
      <SpMenu :currentUser="currentUser"></SpMenu>
    </div>
    <div class="slick" v-if="isTop && bannerList && bannerMode == 1">
      <img v-for="(row, key) in bannerList.list" :key="key" :src="row.file_name">
    </div>
    <div class="movie_area" v-if="isTop && bannerMode == 2">
      <video src="/img/topmovie.mp4" autoplay muted loop playsinline />
    </div>
    <div class='common-header' :class="{second_header:isTop}">
      <div class='name_area'>
        <div class="name" v-if="currentUser.is_login == '1'">
          {{currentUser.last_name}} {{currentUser.first_name}}さん
        </div>
        <div class="point" v-if="currentUser.is_login == '1'">{{availablePoint}}</div>
        <div class="name" v-if="currentUser.is_login == '0'">
          ゲストさん
        </div>
        <a class="login" v-if="currentUser.is_login == '0'" @click="page('/login')">ログイン</a>
      </div>
      <div class="menu_area">
        <a class="mypage" @click="page('/my-page')">マイページ</a>
        <a class="point_buy" @click="page('/buy-point')">ポイント購入</a>
        <a class="item_history" @click="page('/buy-product-history')">商品購入履歴</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainLogo from '@/components/atoms/MainLogo.vue';
import SpMenu from '@/components/molecules/SpMenu.vue';

export default {
  name: 'CommonHeader',

  props: {
    availablePoint: {
      type: String,
      default: '0',
    },
    currentUser: {
      type: Object,
      default: () => {},
    },
    isTop: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    if (this.isTop) {
      this.$store.dispatch('banner/getBannerList');
    }
  },

  mounted() {
    if (this.isTop) {
      window.$(window).off('resize');
      window.$(window).on('resize', () => {
        this.checkBreakPoint();
      });
    }
  },

  components: {
    MainLogo,
    SpMenu,
  },

  computed: {
    ...mapGetters({
      bannerMode: 'banner/bannerMode',
      bannerList: 'banner/bannerList',
    }),
  },

  watch: {
    bannerList() {
      setTimeout(() => {
        this.checkBreakPoint();
      }, 100);
    },
  },

  methods: {
    handleShopNameClick() {
      this.$emit('handleShopNameClick');
    },
    handlePointBoxClick() {
      this.$emit('handlePointBoxClick');
    },
    page(url) {
      this.$router.push(url);
    },
    checkBreakPoint() {
      window.$('.slick.slick-initialized').slick('unslick');
      if (window.$(window).width() <= 768) {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: true,
          arrows: false,
          centerMode: true,
          centerPadding: '0',
        });
      } else {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: true,
          arrows: false,
          variableWidth: true,
          centerMode: true,
          centerPadding: '15%',
        });
        window.$('.slick').slick('slickGoTo', 0, false);
      }
    },
  },

};
</script>
<style lang="scss">
.slick-dots {
  bottom: 10px!important;
}
</style>

<style lang="scss" scoped>
video {
  width: 100%;
  vertical-align:top;
}
.common-header{
  position: fixed;
  border-top: solid 8px $deepGray;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 16px);
  height: 58px;
  background-color: $deepGray;
  padding: 0 10px 0 15px;
  z-index: 101;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: $white;
    &:before {
      content: '';
      width: 24px;
      height: 24px;
      background-size: 100%;
      margin-right: 5px;
    }
  }
  .name_area{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: $white;
    white-space: nowrap;
    padding-left: 210px;
    .name {
      color: #fff;
      margin-right: 20px
    }
    .point {
      color: #f5c236;
      &:before {
        content: "P";
        background-color: $yellow;
        border-radius: 100px;
        color: $deepGray;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
    a.login {
      color: $yellow;
      &:before {
        background-image: url('/img/icon_login.png');
      }
    }
  }
  .menu_area {
    margin-right: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 380px;
    a.mypage {
      &:before {
        background-image: url('/img/icon_mypage.png');
      }
    }
    a.point_buy {
      &:before {
        background-image: url('/img/icon_point.png');
      }
    }
    a.item_history {
      &:before {
        background-image: url('/img/icon_history.png');
      }
    }
  }
}

.slick {
  margin-bottom: 0!important;
  .slick-slide:not(.slick-center) {
    filter: blur(20px);
  }
  .slick-slide {
    max-width: 950px;
    max-height: 475px;
  }
}

.top_header {
  border-top: solid 8px $deepGray;
  .humberger_menu {
    top: 8px;
  }
}
.second_header {
  position: initial;
  width: 100%!important;
}
.movie_area {
  background-color: #000;
  text-align: center;
  video {
    max-width: 1200px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .sp_base_menu {
    background-color: $deepGray;
    width: 100%;
    padding: 8px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 10006;
  }
  .common-header {
    position: fixed;
    top: 40px;
    width: 100%;
    border-top: solid 1px $yellow;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10005;
    .name_area {
      padding-left: 0;
      font-size: 16px;
    }
    .menu_area {
      display: none;
    }
  }
  .slick {
    margin-top: 44px;
  }
  .top_header {
    border-top: none;
  }
  .second_header {
    position: initial;
    width: 100%!important;
  }
  .movie_area {
    margin-top: 45px;
  }
}
</style>
